import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5g4fjz73el: FaireBrandEntity = {
  token: "b_5g4fjz73el",
  type: "brand",
  name: "Oso Rojo Hot Sauce",
  avatarUrl:
    "https://cdn.faire.com/fastly/ab72998e351fbd832a02ecb901d1682c13bd8655a4e44a360249f758e0e00ed4.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/11e12218a682fbeee5250bf21b5aff4f7b9cf1cdc1e1cca490c806d8b7d40298.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/ab72998e351fbd832a02ecb901d1682c13bd8655a4e44a360249f758e0e00ed4.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/11e12218a682fbeee5250bf21b5aff4f7b9cf1cdc1e1cca490c806d8b7d40298.jpeg",
  location: "Denver, CO, USA",
  minimumOrderDollars: 90,
  rating: 5,
  reviewCount: 5,
  isInsider: true,
  description:
    'Welcome to the world\'s friendliest hot sauce! \n\nOso Rojo is a small batch hot sauce company from Denver, CO. \n\nOur motto is "Flavor Before Spice" because our sauces are not hot just to be hot, we want them to compliment the food so you can enjoy your meal. Using our knowledge of peppers and spices we find the perfect balance of heat and flavor for each sauce. \n\nOur 4oz "boston round" bottles are cute and unique, and easy to merchandise on your store shelves. Oso sauces are all natural, vegan and gluten free. ',
  meta: {
    source: "api",
    importedAt: "2026-07-06T19:20:34.000Z",
    importedBy: "entity-db-cli",
  },
};
